<div class="mit-id-container" [class.big-button]="bigButton">
    <button *ngIf="showNormalLogin" class="btn btn-success btn-login" (click)="login()" type="button" [class.loading]="isLoggingIn" [disabled]="isLoggingIn">
        <span>{{ 'SHARED.LOGIN.LOGIN' | translate }}</span>
    </button>

    <ng-container *ngIf="requireSsn">
        <p class="msg msg-error">{{ 'SHARED.LOGIN.COULD_NOT_LOGIN_USE_SSN' | translate }}</p>
        <button class="btn btn-success btn-login" (click)="login()" type="button" [class.loading]="isLoggingIn" [disabled]="isLoggingIn">
            <span>{{ 'SHARED.LOGIN.LOGIN_WITH_SSN' | translate }}</span>
        </button>
    </ng-container>

    <ng-container *ngIf="customerNotFoundError">
        <p class="msg msg-error">{{ 'SHARED.LOGIN.CUSTOMER_NOT_FOUND' | translate }}</p>
    </ng-container>

    <ng-container *ngIf="unknownError">
        <p class="msg msg-error">{{ 'SHARED.LOGIN.UNKNOWN_ERROR' | translate }}</p>
        <button class="btn btn-success btn-login" (click)="login()" type="button" [class.loading]="isLoggingIn" [disabled]="isLoggingIn">
            <span>{{ 'SHARED.LOGIN.LOGIN' | translate }}</span>
        </button>
    </ng-container>
</div>
